import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-print2',
  templateUrl: './print2.component.html',
  styleUrls: ['./print2.component.scss']
})
export class Print2Component implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
